declare var require: any;

import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import './registerServiceWorker';

// Axios
import axios from 'axios';
import VueAxios from 'vue-axios';
import Adal from 'vue-adal';

Vue.use(VueAxios, axios);

// Bootstrap Vue
import BootstrapVue from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import config from '@/services/api-config';

import VueAzureUploader from 'vue-azure-blob-upload';
Vue.use(VueAzureUploader);
import browserDetect from "vue-browser-detect-plugin";
Vue.use(browserDetect);

Vue.use(BootstrapVue);

import Calendar from 'v-calendar/lib/components/calendar.umd'
import DatePicker from 'v-calendar/lib/components/date-picker.umd'


// Register components in your 'main.js'
Vue.component('v-calendar', Calendar)
Vue.component('date-picker', DatePicker)

import '@/styles/global.scss';
import moment from 'moment';
import { GeneralService } from './services/general-service';

const filter = (text, length, clamp) => {
  clamp = clamp || '...';
  const node = document.createElement('div');
  node.innerHTML = text;
  const content = node.textContent;
  if (content !== null) {
    return content.length > length ? content.slice(0, length) + clamp : content;
  }
};

Vue.filter('truncate', filter);



/// login logic

const TOKEN_KEY = 'jwtToken';
const TOKEN_TIME_KEY = 'jwtTokenTime';
const TOKEN_VALIDITY_MINUTES = 630; // same as your token expiry (10h 30m)
const TOKEN_REFRESH_BEFORE_MINUTES = 500; // refresh 30 minutes before expiry

async function refreshJwtTokenIfNeeded() {
  console.log('Checking JWT token');
  const tokenTime = localStorage.getItem(TOKEN_TIME_KEY);
  const username = localStorage.getItem("elp_plus_username");
  if (!tokenTime || !username) return;

  const minutesElapsed = moment().diff(moment(tokenTime), 'minutes');

  // Refresh if time elapsed exceeds refresh-before threshold
  if (minutesElapsed >= TOKEN_REFRESH_BEFORE_MINUTES) {
    console.log('🔄 Refreshing JWT token...');
    try {
      const generalService = new GeneralService();

      const Usernamevalue = "encryptedmobileappsuser@pgc.edu.pk";
      const Passwordvalue = "m#P52s@ap$VP@kht00nKhw@hm#P52s@ap$VP@kht00nKhw@h";
      const DevieId = "";
      const DeviceIP = "";
      const LoginWith = "Web";

      const result = await generalService.gettokenwebsite(
        Usernamevalue,
        Passwordvalue,
        username,
        DevieId,
        DeviceIP,
        LoginWith
      );

      const jwtResponse = result.result?.access_token;
      if (jwtResponse) {
        localStorage.setItem(TOKEN_KEY, jwtResponse);
        localStorage.setItem(TOKEN_TIME_KEY, new Date().toISOString());
        console.log('✅ JWT token refreshed successfully.');
      } else {
        console.warn('⚠️ Failed to refresh JWT token — empty response.');
      }
    } catch (err) {
      console.error('❌ Error while refreshing JWT token:', err);
    }
  }
}

// Check every 10 minutes
setInterval(refreshJwtTokenIfNeeded, 30 * 60 * 1000);

// Run once on load
refreshJwtTokenIfNeeded();


// Vue.mixin({
//   mounted: () => {
//     const mainwrapper = document.getElementsByClassName('main-wrapper')[0];
//     const navbar = document.getElementById('navbar');
//     if (mainwrapper !== undefined && localStorage[config.buttonState] !== undefined){
//       mainwrapper.className = 'main-wrapper ' + localStorage[config.buttonState];
//     } else if (mainwrapper !== undefined){
//       mainwrapper.className = 'main-wrapper dark-theme';

//     }

//     if (navbar !== null){
//       if (localStorage[config.buttonState] === 'light-theme'){
//         if (!navbar.classList.contains('navbar-d')){
//           navbar.classList.add('navbar-d');
//         }
//       } else {
//         if (!navbar.className.includes('navbar-d')){
//           navbar.classList.remove('navbar-d');
//         }
//       }
//     }
//   }
// })


Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');

